import { parseUserHash } from './parseUserHash';
import { saveUser } from '../utility/sessionStorage';
import { saveSessionId } from '../utility/sessionStorage';
import { v4 as uuidv4 } from 'uuid';
import { User } from './User.types';

export const signedOn = (hash: string, callback: (user: User) => void) => {
    // Parse user from url-hash
    const user = parseUserHash(hash);

    // set localstate
    callback(user);
    // Save user in local storage
    const newSessionId = uuidv4() + uuidv4();
    saveSessionId(newSessionId);
    saveUser(user);
};
